import { initStore } from "../hooks/useStore";

const configureOnboardingStore = () => {
  const actions = {
    ADD_FIELD: (curState, field) => {
      const existingField = curState.fields.findIndex(
        (f) => f.name === field.name,
      );

      let updatedFields = [...curState.fields];

      if (existingField === -1) {
        updatedFields = [...updatedFields, field];
      }

      if (existingField >= 0) {
        updatedFields[existingField] = {
          ...curState.fields[existingField],
          value: field.value,
        };
      }
      return { fields: updatedFields };
    },
  };

  initStore(actions, {
    fields: [],
  });
};

export default configureOnboardingStore;
